// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  padding: 0;
  margin: 0;
}

header {
  position: relative;
  background-color: #3f51b5;
  height: 150px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.26);
}

.add-button {
  position: absolute;
  right: 100px;
  bottom: -28px;
  width: 56px;
  height: 56px;
  overflow: visible;
  transition: transform 0.4s cubic-bezier(0.58, -0.37, 0.45, 1.46), color 0s ease 0.4s, font-size 0.2s;
  text-align: center;
  line-height: 56px;
  font-size: 28px;
  color: rgb(255, 255, 255);
}

.add-button:before {
  position: relative;
  z-index: 100;
  content: "+";
}

.add-button:hover {
  color: rgba(255, 255, 255, 0);
  transform: rotate(45deg);
}

.sub-button {
  position: absolute;
  display: inline-block;
  background-color: #ff4081;
  color: rgba(255, 255, 255, 0);
  width: 28px;
  height: 28px;
  line-height: 48px;
  font-family: "FontAwesome";
  font-size: 12px;
  transition: top 0.2s cubic-bezier(0.58, -0.37, 0.45, 1.46) 0.2s, left 0.2s cubic-bezier(0.58, -0.37, 0.45, 1.46) 0.2s, bottom 0.2s cubic-bezier(0.58, -0.37, 0.45, 1.46) 0.2s, right 0.2s cubic-bezier(0.58, -0.37, 0.45, 1.46) 0.2s, width 0.2s cubic-bezier(0.58, -0.37, 0.45, 1.46) 0.2s, height 0.2s cubic-bezier(0.58, -0.37, 0.45, 1.46) 0.2s, transform 0.1s ease 0s, border-radius 0.2s ease 0.2s;
}

.tl {
  top: 0;
  left: 0;
  border-radius: 28px 0 0 0;
}

.tr {
  top: 0;
  right: 0;
  border-radius: 0 28px 0 0;
}

.bl {
  bottom: 0;
  left: 0;
  border-radius: 0 0 0 28px;
}

.br {
  bottom: 0;
  right: 0;
  border-radius: 0 0 28px 0;
}

.tl:before {
  content: "\\f004";
}

.tr:before {
  content: "\\f005";
}

.bl:before {
  content: "\\f041";
}

.br:before {
  content: "\\f075";
}

.add-button:hover .sub-button {
  width: 48px;
  height: 48px;
  transform: rotate(-45deg);
  color: rgb(255, 255, 255);
  transition: top 0.4s cubic-bezier(0.58, -0.37, 0.45, 1.46) 0.4s, left 0.4s cubic-bezier(0.58, -0.37, 0.45, 1.46) 0.4s, bottom 0.4s cubic-bezier(0.58, -0.37, 0.45, 1.46) 0.4s, right 0.4s cubic-bezier(0.58, -0.37, 0.45, 1.46) 0.4s, width 0.4s cubic-bezier(0.58, -0.37, 0.45, 1.46) 0.4s, height 0.4s cubic-bezier(0.58, -0.37, 0.45, 1.46) 0.4s, color 0.3s ease 0.8s, transform 0.3s ease 0.8s, border-radius 0.4s ease 0.6s;
}

.add-button:hover .tl {
  top: -25px;
  left: -25px;
  border-radius: 28px;
}

.add-button:hover .tr {
  top: -25px;
  right: -25px;
  border-radius: 28px;
}

.add-button:hover .bl {
  bottom: -25px;
  left: -25px;
  border-radius: 28px;
}

.add-button:hover .br {
  bottom: -25px;
  right: -25px;
  border-radius: 28px;
}

::ng-deep .mat-mdc-text-field-wrapper {
  background-color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/app/+home/+kanban/board/kanban-menu-actions/kanban-menu-actions.component.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,SAAA;AACF;;AAEA;EACE,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,yCAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EAKA,oGAAA;EAEA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,YAAA;EACA,YAAA;AAFF;;AAMA;EAEE,6BAAA;EACA,wBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,0BAAA;EACA,eAAA;EAiBA,yYAAA;AAlBF;;AA4BA;EACE,MAAA;EACA,OAAA;EACA,yBAAA;AAzBF;;AA4BA;EACE,MAAA;EACA,QAAA;EACA,yBAAA;AAzBF;;AA4BA;EACE,SAAA;EACA,OAAA;EACA,yBAAA;AAzBF;;AA4BA;EACE,SAAA;EACA,QAAA;EACA,yBAAA;AAzBF;;AA4BA;EACE,gBAAA;AAzBF;;AA4BA;EACE,gBAAA;AAzBF;;AA4BA;EACE,gBAAA;AAzBF;;AA4BA;EACE,gBAAA;AAzBF;;AA4BA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EAEA,yBAAA;EAmBA,iaAAA;AA1CF;;AAqDA;EACE,UAAA;EACA,WAAA;EACA,mBAAA;AAlDF;;AAqDA;EACE,UAAA;EACA,YAAA;EACA,mBAAA;AAlDF;;AAqDA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AAlDF;;AAqDA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;AAlDF;;AAoDA;EACE,kCAAA;AAjDF","sourcesContent":["body {\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\nheader {\r\n  position: relative;\r\n  background-color: #3f51b5;\r\n  height: 150px;\r\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.26);\r\n}\r\n\r\n.add-button {\r\n  position: absolute;\r\n  right: 100px;\r\n  bottom: -28px;\r\n  width: 56px;\r\n  height: 56px;\r\n  overflow: visible;\r\n  -webkit-transition: transform .4s cubic-bezier(.58, -0.37, .45, 1.46),\r\n  color 0s ease .4s, font-size .2s;\r\n  -moz-transition: transform .4s cubic-bezier(.58, -0.37, .45, 1.46),\r\n  color 0s ease .4s, font-size .2s;\r\n  transition: transform .4s cubic-bezier(.58, -0.37, .45, 1.46),\r\n  color 0s ease .4s, font-size .2s;\r\n  text-align: center;\r\n  line-height: 56px;\r\n  font-size: 28px;\r\n  color: rgba(255, 255, 255, 1);\r\n}\r\n\r\n.add-button:before {\r\n  position: relative;\r\n  z-index: 100;\r\n  content: \"+\";\r\n\r\n}\r\n\r\n.add-button:hover {\r\n\r\n  color: rgba(255, 255, 255, 0);\r\n  transform: rotate(45deg);\r\n}\r\n\r\n.sub-button {\r\n  position: absolute;\r\n  display: inline-block;\r\n  background-color: #ff4081;\r\n  color: rgba(255, 255, 255, 0);\r\n  width: 28px;\r\n  height: 28px;\r\n  line-height: 48px;\r\n  font-family: \"FontAwesome\";\r\n  font-size: 12px;\r\n  -webkit-transition: top .2s cubic-bezier(.58, -0.37, .45, 1.46) .2s,\r\n  left .2s cubic-bezier(.58, -0.37, .45, 1.46) .2s,\r\n  bottom .2s cubic-bezier(.58, -0.37, .45, 1.46) .2s,\r\n  right .2s cubic-bezier(.58, -0.37, .45, 1.46) .2s,\r\n  width .2s cubic-bezier(.58, -0.37, .45, 1.46) .2s,\r\n  height .2s cubic-bezier(.58, -0.37, .45, 1.46) .2s,\r\n  transform .1s ease 0s,\r\n  border-radius .2s ease .2s;\r\n  -moz-transition: top .2s cubic-bezier(.58, -0.37, .45, 1.46) .2s,\r\n  left .2s cubic-bezier(.58, -0.37, .45, 1.46) .2s,\r\n  bottom .2s cubic-bezier(.58, -0.37, .45, 1.46) .2s,\r\n  right .2s cubic-bezier(.58, -0.37, .45, 1.46) .2s,\r\n  width .2s cubic-bezier(.58, -0.37, .45, 1.46) .2s,\r\n  height .2s cubic-bezier(.58, -0.37, .45, 1.46) .2s,\r\n  transform .1s ease 0s,\r\n  border-radius .2s ease .2s;\r\n  transition: top .2s cubic-bezier(.58, -0.37, .45, 1.46) .2s,\r\n  left .2s cubic-bezier(.58, -0.37, .45, 1.46) .2s,\r\n  bottom .2s cubic-bezier(.58, -0.37, .45, 1.46) .2s,\r\n  right .2s cubic-bezier(.58, -0.37, .45, 1.46) .2s,\r\n  width .2s cubic-bezier(.58, -0.37, .45, 1.46) .2s,\r\n  height .2s cubic-bezier(.58, -0.37, .45, 1.46) .2s,\r\n  transform .1s ease 0s,\r\n  border-radius .2s ease .2s;\r\n}\r\n\r\n.tl {\r\n  top: 0;\r\n  left: 0;\r\n  border-radius: 28px 0 0 0;\r\n}\r\n\r\n.tr {\r\n  top: 0;\r\n  right: 0;\r\n  border-radius: 0 28px 0 0;\r\n}\r\n\r\n.bl {\r\n  bottom: 0;\r\n  left: 0;\r\n  border-radius: 0 0 0 28px;\r\n}\r\n\r\n.br {\r\n  bottom: 0;\r\n  right: 0;\r\n  border-radius: 0 0 28px 0;\r\n}\r\n\r\n.tl:before {\r\n  content: \"\";\r\n}\r\n\r\n.tr:before {\r\n  content: \"\";\r\n}\r\n\r\n.bl:before {\r\n  content: \"\";\r\n}\r\n\r\n.br:before {\r\n  content: \"\";\r\n}\r\n\r\n.add-button:hover .sub-button {\r\n  width: 48px;\r\n  height: 48px;\r\n  transform: rotate(-45deg);\r\n\r\n  color: rgba(255, 255, 255, 1);\r\n  -webkit-transition: top .4s cubic-bezier(.58, -0.37, .45, 1.46) .4s,\r\n  left .4s cubic-bezier(.58, -0.37, .45, 1.46) .4s,\r\n  bottom .4s cubic-bezier(.58, -0.37, .45, 1.46) .4s,\r\n  right .4s cubic-bezier(.58, -0.37, .45, 1.46) .4s,\r\n  width .4s cubic-bezier(.58, -0.37, .45, 1.46) .4s,\r\n  height .4s cubic-bezier(.58, -0.37, .45, 1.46) .4s,\r\n  color .3s ease .8s,\r\n  transform .3s ease .8s,\r\n  border-radius .4s ease .6s;\r\n  -moz-transition: top .4s cubic-bezier(.58, -0.37, .45, 1.46) .4s,\r\n  left .4s cubic-bezier(.58, -0.37, .45, 1.46) .4s,\r\n  bottom .4s cubic-bezier(.58, -0.37, .45, 1.46) .4s,\r\n  right .4s cubic-bezier(.58, -0.37, .45, 1.46) .4s,\r\n  width .4s cubic-bezier(.58, -0.37, .45, 1.46) .4s,\r\n  height .4s cubic-bezier(.58, -0.37, .45, 1.46) .4s,\r\n  color .3s ease .8s,\r\n  transform .3s ease .8s,\r\n  border-radius .4s ease .6s;\r\n  transition: top .4s cubic-bezier(.58, -0.37, .45, 1.46) .4s,\r\n  left .4s cubic-bezier(.58, -0.37, .45, 1.46) .4s,\r\n  bottom .4s cubic-bezier(.58, -0.37, .45, 1.46) .4s,\r\n  right .4s cubic-bezier(.58, -0.37, .45, 1.46) .4s,\r\n  width .4s cubic-bezier(.58, -0.37, .45, 1.46) .4s,\r\n  height .4s cubic-bezier(.58, -0.37, .45, 1.46) .4s,\r\n  color .3s ease .8s,\r\n  transform .3s ease .8s,\r\n  border-radius .4s ease .6s;\r\n}\r\n\r\n.add-button:hover .tl {\r\n  top: -25px;\r\n  left: -25px;\r\n  border-radius: 28px;\r\n}\r\n\r\n.add-button:hover .tr {\r\n  top: -25px;\r\n  right: -25px;\r\n  border-radius: 28px;\r\n}\r\n\r\n.add-button:hover .bl {\r\n  bottom: -25px;\r\n  left: -25px;\r\n  border-radius: 28px;\r\n}\r\n\r\n.add-button:hover .br {\r\n  bottom: -25px;\r\n  right: -25px;\r\n  border-radius: 28px;\r\n}\r\n::ng-deep .mat-mdc-text-field-wrapper {\r\n  background-color: white !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
